<template>
    <div class="advisor-search-result" role="group" aria-label="advisor">
        <div class="container">
            <div class="advisor-row">
                <div class="advisor-image">
                    <a href="javascript:;" v-on:click.stop="selectedAdvisorClick(advisor, 'image')">
                        <img style="width:125px" :alt="(advisor.firstName + ' ' + advisor.lastName)" :src="advisor.image" />
                    </a>
                </div>
                <div class="advisor-name">
                    <a href="javascript:;" v-on:click.stop="selectedAdvisorClick(advisor, 'name')">
                        <h2 class="h5">{{ advisor.firstName }} {{ advisor.lastName }}</h2>
                    </a>
                    <p v-if="advisor.advisorTitle">{{ advisor.advisorTitle }}</p>
                    <p v-if="advisor.nmlsNumber">{{ text("nmls") }} #{{ advisor.nmlsNumber }}</p>
                </div>
                <div v-if="!isDirectConsumer" class="advisor-branch" v-html="address">
                </div>
                <div class="advisor-distance">
                    <div class="advisor-distance-wrap" v-if="advisor.distance > 0">
                        <p>{{ distance }}</p>
                    </div>
                </div>
                <div class="advisor-caret">
                    <a href="javascript:;" v-on:click="selectedAdvisorClick(advisor, 'arrow')">
                        <svg role="img" :aria-labelledby="advisor.id"
                            width="2em"
                            height="2em"
                            viewBox="0 0 16 16"
                            class="bi bi-chevron-right"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                          <title :id="advisor.id">{{ advisor.firstName }} {{ advisor.lastName }} Details</title>
                            <path
                            fill-rule="evenodd"
                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                            />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "../functions/eventBus";
import { locText } from "../../../utils/useText";
import { formatAddress } from "../../../utils/functions";

export default {
    data() {
        return {

        }
    },
    computed: {
        address() {
            if (this.advisor.address) {
                return (this.advisor.address.addressLine1 != null ? ("<p>" + this.advisor.address.addressLine1 + (this.advisor.address.addressLine2 != null ? ("<br />" + this.advisor.address.addressLine2 + "</p>") : "</p>")) : "") +
                    "<p>" + (this.advisor.address.city != null ? this.advisor.address.city : "") +
                    ((this.advisor.address.city != null ? ", " : "") + (this.advisor.address.state != null ? this.advisor.address.state : "")) +
                    ((this.advisor.address.state != null ? " " : "") + (this.advisor.address.zip != null ? this.advisor.address.zip : "")) + "</p>";
            }
        },
        distance() {
            return parseFloat(this.advisor.distance).toFixed(1) + " " + this.text("distance");
        },
        userSearchLocation() {
            return this.$store.getters.userSearchLocation;
        },
        isDirectConsumer: {
            get() {
                return this.$store.getters.isDirectConsumer;
            }
        }
    },
    mixins: [locText],
    props: {
        advisor: Object,
        selectedAdvisorClick: Function
    }
}
</script>
